const DOMElements = {
  featuredImage: () => document.querySelector(".product__featured-image"),
  gallery: () => document.querySelector(".desktop-gallery"),
  details: () => document.querySelector(".product__info"),
  quantityControls: {
    addButton: () =>
      document.querySelector(".product__quantity-button--increase"),
    removeButton: () =>
      document.querySelector(".product__quantity-button--decrease"),
    input: () => document.querySelector(".product__quantity-input"),
  },
  galleryItems: () => document.querySelectorAll(".product__gallery-item"),
  galleryDots: () => document.querySelectorAll(".product__gallery-dot"),
  variantControls: {
    select: () => document.getElementById("product-select"),
    optionSelects: () => document.querySelectorAll(".product__option"),
  },
};

const setImageHeight = () => {
  const { featuredImage, gallery, details } = DOMElements;
  const featuredImageEl = featuredImage();
  const galleryEl = gallery();
  const detailsEl = details();

  if (featuredImageEl && galleryEl && detailsEl) {
    // Verificar se estamos em um dispositivo móvel (largura menor que 768px)
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // Em dispositivos móveis, não limitamos a altura do conteúdo
      // ou definimos uma altura mínima para garantir que o conteúdo seja visível
      detailsEl.style.maxHeight = "none";

      // A galeria desktop não é exibida em dispositivos móveis conforme o CSS,
      // mas definimos mesmo assim para garantir
      galleryEl.style.maxHeight = "none";
    } else {
      // Em desktop, mantemos o comportamento original
      const height = `${featuredImageEl.offsetHeight}px`;
      galleryEl.style.maxHeight = height;
      detailsEl.style.maxHeight = height;
    }
  }
};

// Função initQuantityControls removida para evitar duplicidade com a função changeQuantity
// que já está sendo chamada diretamente pelos botões no HTML
const initQuantityControls = () => {
  // Função desativada para evitar chamadas duplicadas
  return;
};

const handleImageTransition = (featuredImage, newSrc, newImageId) => {
  featuredImage.classList.add("transition");

  featuredImage.src = newSrc;
  featuredImage.setAttribute("data-image-id", newImageId);

  setTimeout(() => {
    featuredImage.classList.remove("transition");
  }, 300);
};

const initGalleryControls = () => {
  const galleryItems = DOMElements.galleryItems();
  const galleryDots = DOMElements.galleryDots();
  const featuredImage = DOMElements.featuredImage();
  const upButton = document.querySelector(".product__gallery-button.--up");
  const downButton = document.querySelector(".product__gallery-button.--down");

  if (!featuredImage || !galleryItems.length) return;

  // Atualizar estado dos botões no carregamento inicial
  const updateGalleryButtons = () => {
    const currentImageId = featuredImage.getAttribute("data-image-id");
    const allImages = Array.from(galleryItems);
    const currentIndex = allImages.findIndex(
      (item) => item.getAttribute("data-image-id") === currentImageId
    );

    if (upButton) {
      upButton.disabled = currentIndex === 0;
    }
    if (downButton) {
      downButton.disabled = currentIndex === allImages.length - 1;
    }
  };

  // Chamar updateGalleryButtons imediatamente após inicialização
  updateGalleryButtons();

  const navigateGallery = (direction) => {
    const currentImageId = featuredImage.getAttribute("data-image-id");
    const allImages = Array.from(galleryItems);
    const currentIndex = allImages.findIndex(
      (item) => item.getAttribute("data-image-id") === currentImageId
    );

    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < allImages.length) {
      const targetItem = allImages[newIndex];
      const galleryImage = targetItem.querySelector("img");
      const imageId = targetItem.getAttribute("data-image-id");

      handleImageTransition(featuredImage, galleryImage.src, imageId);
      updateActiveGalleryItem();
      updateGalleryButtons();

      // Scroll do item para a visualização
      const galleryList = document.querySelector(".product__gallery-list");
      if (galleryList) {
        const itemRect = targetItem.getBoundingClientRect();
        const listRect = galleryList.getBoundingClientRect();

        // Verificar se o item está fora da área visível
        if (itemRect.top < listRect.top || itemRect.bottom > listRect.bottom) {
          targetItem.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }
    }
  };

  // Add click handlers for navigation buttons
  if (upButton) {
    upButton.addEventListener("click", () => navigateGallery(-1));
  }
  if (downButton) {
    downButton.addEventListener("click", () => navigateGallery(1));
  }

  const updateActiveGalleryItem = () => {
    const currentImageId = featuredImage.getAttribute("data-image-id");

    // Update active state for gallery items (desktop)
    if (galleryItems.length) {
      galleryItems.forEach((item) => {
        const isActive = item.getAttribute("data-image-id") === currentImageId;
        item.classList.toggle("active", isActive);
      });
    }

    // Update active state for gallery dots (mobile)
    if (galleryDots.length) {
      galleryDots.forEach((dot) => {
        const isActive = dot.getAttribute("data-image-id") === currentImageId;
        dot.classList.toggle("active", isActive);
      });
    }

    updateGalleryButtons();
  };

  updateActiveGalleryItem();

  // Desktop gallery item click handlers
  if (galleryItems.length) {
    galleryItems.forEach((item) => {
      item.addEventListener("click", () => {
        const galleryImage = item.querySelector("img");
        const imageId = item.getAttribute("data-image-id");

        handleImageTransition(featuredImage, galleryImage.src, imageId);
        updateActiveGalleryItem();
      });
    });
  }

  // Mobile gallery dots click handlers
  if (galleryDots.length) {
    galleryDots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const imageId = dot.getAttribute("data-image-id");
        const matchingItem = Array.from(galleryItems).find(
          (item) => item.getAttribute("data-image-id") === imageId
        );

        if (matchingItem) {
          const galleryImage = matchingItem.querySelector("img");
          handleImageTransition(featuredImage, galleryImage.src, imageId);
          updateActiveGalleryItem();
        }
      });
    });
  }

  // Initialize touch swipe for mobile gallery
  initMobileGallerySwipe();
};

const initVariantImageSelector = () => {
  const { select: variantSelect, optionSelects } = DOMElements.variantControls;
  const variantSelectEl = variantSelect();
  const optionSelectsEl = optionSelects();
  const featuredImage = DOMElements.featuredImage();
  const galleryItems = DOMElements.galleryItems();

  if (!variantSelectEl || !featuredImage || !galleryItems.length) return;

  let variantManuallyChanged = false;

  const findGalleryItemByImageId = (imageId) => {
    return Array.from(galleryItems).find(
      (item) => item.getAttribute("data-image-id") === imageId
    );
  };

  const updateImageByVariant = (imageId) => {
    if (!imageId || !variantManuallyChanged) return;

    const matchingGalleryItem = findGalleryItemByImageId(imageId);

    if (matchingGalleryItem) {
      const galleryImage = matchingGalleryItem.querySelector("img");
      handleImageTransition(featuredImage, galleryImage.src, imageId);

      galleryItems.forEach((item) => {
        item.classList.toggle("active", item === matchingGalleryItem);
      });
    }
  };

  const handleVariantChange = () => {
    if (!variantManuallyChanged) return;

    const selectedOption =
      variantSelectEl.options[variantSelectEl.selectedIndex];
    if (!selectedOption) return;

    const imageId = selectedOption.getAttribute("data-image-id");
    updateImageByVariant(imageId);
  };

  const updateVariantSelection = () => {
    variantManuallyChanged = true;

    const selectedOptions = Array.from(optionSelectsEl).map(
      (select) => select.value
    );

    const variants = Array.from(variantSelectEl.options);
    for (const variant of variants) {
      const variantTitle = variant.textContent.trim().split(" - ")[0];
      const variantOptions = variantTitle.split(" / ");

      const isMatch = selectedOptions.every(
        (option, index) => variantOptions[index] === option
      );

      if (isMatch) {
        variantSelectEl.value = variant.value;
        handleVariantChange();
        // Update price display when variant changes
        updatePriceDisplay(variant);
        break;
      }
    }
  };

  optionSelectsEl.forEach((select) => {
    select.addEventListener("change", updateVariantSelection);
  });

  const currentImageId = featuredImage.getAttribute("data-image-id");
  const initialGalleryItem = findGalleryItemByImageId(currentImageId);
  if (initialGalleryItem) {
    initialGalleryItem.classList.add("active");
  }
};

// Mobile gallery swipe functionality
const initMobileGallerySwipe = () => {
  const featuredImage = DOMElements.featuredImage();
  const galleryDots = DOMElements.galleryDots();
  const galleryItems = DOMElements.galleryItems();

  if (!featuredImage || !galleryItems.length) return;

  let touchStartX = 0;
  let touchEndX = 0;

  featuredImage.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );

  featuredImage.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    },
    { passive: true }
  );

  const handleSwipe = () => {
    const currentImageId = featuredImage.getAttribute("data-image-id");
    const allImages = Array.from(galleryItems);
    const currentIndex = allImages.findIndex(
      (item) => item.getAttribute("data-image-id") === currentImageId
    );

    if (currentIndex === -1) return;

    let newIndex;
    // Swipe left (next image)
    if (touchEndX < touchStartX - 50) {
      newIndex = currentIndex < allImages.length - 1 ? currentIndex + 1 : 0;
    }
    // Swipe right (previous image)
    else if (touchEndX > touchStartX + 50) {
      newIndex = currentIndex > 0 ? currentIndex - 1 : allImages.length - 1;
    } else {
      return; // Not a significant swipe
    }

    const nextItem = allImages[newIndex];
    if (!nextItem) return;

    const galleryImage = nextItem.querySelector("img");
    if (!galleryImage) return;

    const imageId = nextItem.getAttribute("data-image-id");

    handleImageTransition(featuredImage, galleryImage.src, imageId);

    // Update active states for gallery dots (mobile)
    if (galleryDots && galleryDots.length) {
      galleryDots.forEach((dot) => {
        const dotImageId = dot.getAttribute("data-image-id");
        if (dotImageId === imageId) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }

    // Update active states for gallery items (desktop)
    galleryItems.forEach((item) => {
      const itemImageId = item.getAttribute("data-image-id");
      if (itemImageId === imageId) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  };
};

// Function to update price display when variant changes
const updatePriceDisplay = (selectedOption) => {
  if (!selectedOption) return;

  // Extrai o preço da opção selecionada
  const priceText = selectedOption.textContent.split(" - ")[1];
  if (!priceText) return;

  // Converte o texto do preço para número, removendo pontos de milhar e trocando vírgula por ponto
  const price = parseFloat(
    priceText
      .replace(/[^\d,]/g, "") // Remove tudo exceto dígitos e vírgula
      .replace(",", ".") // Troca vírgula por ponto
  );

  if (isNaN(price)) return;

  // Atualiza os elementos de preço
  const regularPriceElement = document.querySelector(".product__price-regular");
  const discountPriceElement = document.querySelector(".product__price-value");
  const savingsElement = document.querySelector(".product__price-savings");

  if (regularPriceElement) {
    regularPriceElement.textContent = priceText;
  }

  if (discountPriceElement) {
    // Calcula o preço com 5% de desconto para PIX
    const discountPrice = price * 0.95;
    const formattedDiscountPrice = formatPrice(discountPrice);
    discountPriceElement.textContent = formattedDiscountPrice;
  }

  if (savingsElement) {
    // Calcula e atualiza a porcentagem de desconto
    const savings = 5; // 5% fixo de desconto
    savingsElement.textContent = `(${savings}% off)`;
  }

  // Recalcula as parcelas no popup de pagamento
  calculateInstallments();
};

// Função auxiliar para formatar preço
function formatPrice(value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

function calculateInstallments() {
  const variantSelect = document.getElementById("product-select");
  if (!variantSelect) return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  if (!selectedOption) return;

  const priceText = selectedOption.textContent.split(" - ")[1];
  if (!priceText) return;

  // Converter o preço corretamente, removendo R$ e convertendo vírgula para ponto
  const price = parseFloat(
    priceText
      .replace(/[R$\s.]/g, "") // Remove R$, espaços e pontos
      .replace(",", ".") // Troca vírgula por ponto para cálculo
  );

  if (isNaN(price)) return;

  const creditCardContent = document.getElementById("credit-card-content");
  if (!creditCardContent) return;

  const installmentsContainer = creditCardContent.querySelector(
    ".payment-methods-popup__installments"
  );
  if (!installmentsContainer) return;

  // Limpar todo o conteúdo anterior
  installmentsContainer.innerHTML = "";

  // Adicionar opção à vista
  const cashElement = document.createElement("div");
  cashElement.className = "payment-methods-popup__installment";
  cashElement.innerHTML = `
    <span>À vista</span>
    <span class="payment-methods-popup__price">Total: ${formatPrice(
      price
    )}</span>
  `;
  installmentsContainer.appendChild(cashElement);

  // Calcular o número máximo de parcelas
  const maxInstallments = Math.min(10, Math.floor(price / 50));

  // Gerar as parcelas
  for (let i = 2; i <= maxInstallments; i++) {
    const jurosAcumulado = i * 0.0219;
    const fatorMultiplicador = 1 + jurosAcumulado;
    const valorTotalComJuros = price * fatorMultiplicador;
    const valorParcela = valorTotalComJuros / i;

    const installmentElement = document.createElement("div");
    installmentElement.className = "payment-methods-popup__installment";
    installmentElement.innerHTML = `
      <span>${i}x de ${formatPrice(valorParcela)}</span>
      <span class="payment-methods-popup__price">Total: ${formatPrice(
        valorTotalComJuros
      )}</span>
    `;

    installmentsContainer.appendChild(installmentElement);
  }

  // Atualizar o texto de parcelas na página do produto
  updateInstallmentText(maxInstallments);
}

function updateInstallmentText(maxInstallments) {
  const installmentElement = document.querySelector(
    ".product__price-installment"
  );
  if (installmentElement && maxInstallments > 1) {
    installmentElement.innerHTML = `ou em <strong>${maxInstallments}x</strong> com juros no cartão`;
  }
}

const initPage = () => {
  setImageHeight();
  initQuantityControls();
  initGalleryControls();
  initVariantImageSelector();

  // Connect buttons to functions
  const addToCartButton = document.getElementById("add-to-cart-button");
  if (addToCartButton) {
    addToCartButton.addEventListener("click", addToCart);
  }

  const buyNowButton = document.querySelector(".product__button--buy");
  if (buyNowButton) {
    buyNowButton.addEventListener("click", buyNow);
  }

  // Initialize with the default variant price
  const variantSelect = document.getElementById("product-select");
  if (variantSelect && variantSelect.options.length > 0) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      updatePriceDisplay(selectedOption);
    }
  }
};

window.addEventListener("load", initPage);
window.addEventListener("resize", setImageHeight);

// Garantir que a altura seja recalculada quando a orientação do dispositivo mudar
window.addEventListener("orientationchange", setImageHeight);

function selectGalleryImage(img) {
  const featured = document.getElementById("featured-img");
  featured.src = img.src;
  featured.setAttribute("data-image-id", img.getAttribute("data-image-id"));
  document
    .querySelectorAll(".gallery-img")
    .forEach((i) => i.classList.remove("active"));
  img.classList.add("active");
}

function changeQuantity(delta) {
  const input = document.querySelector(".product__quantity-input");
  if (!input) return;

  let value = parseInt(input.value, 10) || 1;
  value += delta;

  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || 99;

  if (value < min) value = min;
  if (value > max) value = max;

  input.value = value;

  // Disparar evento de mudança para atualizar qualquer lógica dependente
  const event = new Event("change", { bubbles: true });
  input.dispatchEvent(event);
}

function addToCart() {
  const variantId = document.getElementById("product-select").value;
  const quantity =
    parseInt(document.querySelector(".product__quantity-input").value, 10) || 1;

  if (!variantId) {
    alert("Por favor, selecione uma variante do produto");
    return;
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then((r) => r.json())
    .then(() => {
      // Substituir reload por abertura do cart-drawer
      const cartDrawer = document.getElementById("cart-drawer");
      const cartOverlay = document.getElementById("cart-drawer-overlay");

      if (cartDrawer && cartOverlay) {
        cartDrawer.classList.add("active");
        cartOverlay.classList.add("active");
        document.body.style.overflow = "hidden";

        // Disparar evento de atualização do carrinho
        document.dispatchEvent(new CustomEvent("cart:updated"));
      }
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      alert(
        "Ocorreu um erro ao adicionar ao carrinho. Por favor, tente novamente."
      );
    });
}

function buyNow() {
  const variantId = document.getElementById("product-select").value;
  const quantity =
    parseInt(document.querySelector(".product__quantity-input").value, 10) || 1;

  if (!variantId) {
    alert("Por favor, selecione uma variante do produto");
    return;
  }

  // Add to cart via fetch and then redirect to checkout
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then((r) => r.json())
    .then(() => {
      // Redirect to checkout immediately after successful cart addition
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      alert(
        "Ocorreu um erro ao adicionar ao carrinho. Por favor, tente novamente."
      );
    });
}

function updateVariant() {
  const selects = document.querySelectorAll(".option-select");
  const variantSelect = document.getElementById("product-select");
  const selected = Array.from(selects)
    .map((s) => s.value)
    .join(" / ");

  let selectedVariant = null;
  Array.from(variantSelect.options).forEach((opt) => {
    if (opt.textContent.startsWith(selected)) {
      variantSelect.value = opt.value;
      selectedVariant = opt;
    }
  });

  // Update price display with selected variant price
  if (selectedVariant) {
    updatePriceDisplay(selectedVariant);
  }
}

function showPaymentMethods() {
  const popup = document.getElementById("payment-methods-popup");
  if (popup) {
    // Calcular as parcelas
    calculateInstallments();
    // Mostrar o popup
    popup.style.display = "flex";
    document.body.style.overflow = "hidden"; // Impedir rolagem da página
  }
}

function closePaymentMethods() {
  const popup = document.getElementById("payment-methods-popup");
  if (popup) {
    popup.style.display = "none";
    document.body.style.overflow = ""; // Restaurar rolagem da página
  }
}

// Inicializar as abas do popup de formas de pagamento
function initPaymentTabs() {
  const tabs = document.querySelectorAll(".payment-methods-popup__tab");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remover classe active de todas as abas
      tabs.forEach((t) => t.classList.remove("active"));

      // Adicionar classe active na aba clicada
      this.classList.add("active");

      // Esconder todos os conteúdos
      const contents = document.querySelectorAll(
        ".payment-methods-popup__tab-content"
      );
      contents.forEach((content) => content.classList.remove("active"));

      // Mostrar o conteúdo correspondente
      const tabId = this.getAttribute("data-tab");
      const content = document.getElementById(`${tabId}-content`);
      if (content) {
        content.classList.add("active");
      }
    });
  });
}

// Conectar o botão de formas de pagamento ao evento de clique
document.addEventListener("DOMContentLoaded", function () {
  const paymentButton = document.querySelector(".product__button--payment");
  if (paymentButton) {
    paymentButton.addEventListener("click", showPaymentMethods);
  }

  // Inicializar as parcelas
  calculateInstallments();

  // Inicializar as abas
  initPaymentTabs();

  // Fechar o popup quando clicar fora do conteúdo
  const popup = document.getElementById("payment-methods-popup");
  if (popup) {
    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        closePaymentMethods();
      }
    });
  }

  // Ajustar layout em telas pequenas
  adjustLayoutForSmallScreens();
  window.addEventListener("resize", adjustLayoutForSmallScreens);
});

// Função para ajustar o layout em telas pequenas
function adjustLayoutForSmallScreens() {
  const isMobile = window.innerWidth <= 480;
  const quantityInput = document.querySelector(".product__quantity-input");

  if (quantityInput && isMobile) {
    // Ajustar largura do input de quantidade em telas pequenas
    quantityInput.style.width = "auto";
  } else if (quantityInput) {
    quantityInput.style.width = "100px";
  }
}

function formatZipCode(input) {
  let value = input.value.replace(/\D/g, "");
  if (value.length > 5)
    value = value.substring(0, 5) + "-" + value.substring(5, 8);
  input.value = value.substring(0, 9);
}

// Função removida conforme solicitado
// function calculateShipping() {
//   alert("Calcular frete");
// }
